// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.plans-table {
  padding: 30px 14% 0 14%;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.plans-title {
  font-size: 36px;
  font-weight: 500;
  color: #052456;
}
.create-plan-btn {
  background-color: #f15e22;
  color: white;
  border: none;
  border-radius: 40px;
  min-height: 48px;
  min-width: 148px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.create-plan-btn:hover {
  background-color: #e65a50;
}

.plans-table-paper {
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
}

.plans-header-row {
  height: 60px;
  display: flex;
  justify-content: space-between;
}

.plans-table-header {
  padding: 10px;
  font-weight: 700 !important;
  background-color: #efefef;
}

.plans-table-header-first-col {
  border-top-left-radius: 20px;
}

.plans-table-header-last-col {
  border-top-right-radius: 20px;
  width: 130px;
  padding: 16px 0px 16px 24px !important;
}

.plans-table-row:hover {
  background-color: #f9f9f9;
  cursor: pointer;
}

.plans-menu-items{
  width:150px ;
}

.no-data-admin{
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/plans/plans.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB","sourcesContent":[".plans-table {\n  padding: 30px 14% 0 14%;\n}\n\n.header-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.plans-title {\n  font-size: 36px;\n  font-weight: 500;\n  color: #052456;\n}\n.create-plan-btn {\n  background-color: #f15e22;\n  color: white;\n  border: none;\n  border-radius: 40px;\n  min-height: 48px;\n  min-width: 148px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n.create-plan-btn:hover {\n  background-color: #e65a50;\n}\n\n.plans-table-paper {\n  border-top-left-radius: 20px !important;\n  border-top-right-radius: 20px !important;\n}\n\n.plans-header-row {\n  height: 60px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.plans-table-header {\n  padding: 10px;\n  font-weight: 700 !important;\n  background-color: #efefef;\n}\n\n.plans-table-header-first-col {\n  border-top-left-radius: 20px;\n}\n\n.plans-table-header-last-col {\n  border-top-right-radius: 20px;\n  width: 130px;\n  padding: 16px 0px 16px 24px !important;\n}\n\n.plans-table-row:hover {\n  background-color: #f9f9f9;\n  cursor: pointer;\n}\n\n.plans-menu-items{\n  width:150px ;\n}\n\n.no-data-admin{\n  display: flex;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
